var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-led",class:( _obj = {}, _obj['c-led-' + _vm.color] = true, _obj['c-led-on'] =  _vm.on, _obj['c-led-off'] =  !_vm.on, _obj['c-led-pulsate'] =  _vm.pulsate, _obj )},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-led-content"},[_c('div',{staticClass:"c-led-dot"})])}]

export { render, staticRenderFns }